/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import axios from 'axios';
import router from '../router/index';
import { Message } from 'element-ui';
import qs from 'qs';

/* if (process.env.NODE_ENV == 'development') {    
    axios.defaults.baseURL = 'http://test.rooibook.com/pms';} 
else if (process.env.NODE_ENV == 'debug') {    
    axios.defaults.baseURL = 'http://test.rooibook.com/pms';
} 
else if (process.env.NODE_ENV == 'production') {    
    axios.defaults.baseURL = 'http://test.rooibook.com/pms';
} */

// 创建axios实例
var instance = axios.create({
  timeout: 1000 * 30,
});
let errName = '重复请求';

const pending = {};
const CancelToken = axios.CancelToken;
const removePending = (key, isRequest = false) => {
  if (pending[key] && isRequest) {
    pending[key](errName);
  }
  delete pending[key];
};

const getRequestIdentify = (config, isReuest = false) => {
  let url = config.url;
  if (isReuest) {
    url = config.baseURL + config.url.substring(1, config.url.length);
  }
  return config.method === 'get' ? encodeURIComponent(url + JSON.stringify(config.params)) : encodeURIComponent(config.url + JSON.stringify(config.data));
};

/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  config => {
    // 登录流程控制中，根据本地是否存在token判断用户的登录情况
    // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
    // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
    // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。
    const token = localStorage.getItem('token');
    // console.log(token);
    token && (config.headers.Authorization = 'Bearer ' + token);

    if (config.method === 'get') {
      config.paramsSerializer = function (params) {
        return qs.stringify(params, {
          arrayFormat: 'repeat',
          skipNulls: true,
        });
      };
      for (let key in config.params) {
        if (config.params[key] === '') {
          config.params[key] = undefined;
        }
      }
    }

    //拦截重复请求
    let requestData = getRequestIdentify(config, true);
    removePending(requestData, true);

    config.cancelToken = new CancelToken(c => {
      pending[requestData] = c;
    });

    return config;
  },
  error => {
    console.log('报错', error);
    Promise.error(error);
  }
);
// 响应拦截器
instance.interceptors.response.use(
  // 请求成功
  res => {
    // console.log(res);
    if (!res.data.status) {
      return Promise.resolve(res);
    } else if (res.data.status == '403') {
      // Notification.error({
      //     title: '登录失败',
      //     message: res.data.message
      // })
      router.replace({
        path: '/login',
      });
      return;
    } else if (res.data.status == '4049') {
      Message.error({
        title: res.data.message,
        message: res.data.message,
      });
      localStorage.setItem('posCode', res.data.data.posCode);

      return;
    } else if (res.data.status == '401' && res.data.status == '403') {
      Message.error({
        title: res.data.message,
        message: res.data.message,
      });

      router.replace({
        path: '/login',
      });
      return;
    } else if (res.data.status == '500') {
      Message.error({
        title: res.data.message,
        message: res.data.message,
      });

      router.replace({
        path: '/login',
      });
      return;
    } else {
      console.log('参数异常', res);
      Message.error({
        title: res.data.message,
        message: res.data.message,
        duration: 3000,
      });

      return Promise.reject();
    }
  },
  // 请求失败
  error => {
    console.log('报错', error);
    if (error.message == 'Network Error') {
      // Notification.error({
      //     title: '请求超时',
      //     message: error.message
      // })
      router.replace({
        path: '/login',
      });
    }
  }
);

export default instance;
